/* eslint-disable jsx-a11y/control-has-associated-label,jsx-a11y/alt-text */

'use client';

import styled from '@emotion/styled';
import { useMemo } from 'react';
import { WebViewScreen } from '@diritto/common/app/webview-header.constant';
import { HELP_URL } from '@diritto/common/constants/url';
import { isPC, PCOffset } from '@/constants/layout';
import { MutableHeaderLayout } from 'ui-components/layout/MutableHeaderLayout';
import { useInAppHeader } from 'ui-hooks/useInAppHeader';
import { useInAppStatusBar } from 'ui-hooks/useInAppStatusBar';
import { configure } from 'utils/configure';
import { useResponsiveImageMap } from '@/ui-hooks/useResponsiveImageMap';
import { useViewPort } from '@/ui-hooks/useViewPort';

export const TopTenPage = ({ isApp }: { isApp?: boolean }) => {
  useInAppHeader({ screen: WebViewScreen.PickAndChoo, title: '픽앤츄 with RIDI' });
  useInAppStatusBar(WebViewScreen.PickAndChoo);

  const { width: screenWidth } = useViewPort();
  const contentWidth = useMemo(
    () => (screenWidth > PCOffset ? Math.min(screenWidth, 730) : screenWidth),
    [screenWidth],
  );

  const scale = useMemo(() => contentWidth / 730, [contentWidth]);
  const HELP_QNA_URL = `${HELP_URL}/hc/ko/articles/11723419022351-판타지-픽앤츄`;
  useResponsiveImageMap('image2', 'image-map2');
  useResponsiveImageMap('image3', 'image-map3');

  return (
    <MutableHeaderLayout title="2025 판타지 픽앤츄" noBottomPadding isApp={isApp}>
      <div className="relative flex flex-col items-center gap-0">
        <div className="flex justify-center w-full bg-[#EFEBFA]">
          <img alt="event" src={`${configure.staticPrefix}/images/contests/3/top10/1.png`} className="w-full h-auto" />
        </div>
        <div className="flex justify-center w-full bg-[#EFEBFA]">
          <img
            alt="event"
            id="image2"
            useMap="#image-map2"
            src={`${configure.staticPrefix}/images/contests/3/top10/2.png?03`}
            className="w-full h-auto"
          />
          <StyledScaleWrapper scale={scale} className="absolute left-0 w-full">
            <map name="image-map2">
              <area
                target="_self"
                alt="괴이 때문에 집값이 떨어진다"
                title="괴이 때문에 집값이 떨어진다"
                href="/contents/2400531"
                coords="154,906,2021,1552"
                shape="rect"
              />
              <area
                target="_self"
                alt="귀신을 본다고요? 당장 입사합시다"
                title="귀신을 본다고요? 당장 입사합시다"
                href="/contents/2400377"
                coords="164,1748,2045,2393"
                shape="rect"
              />
              <area
                target="_self"
                alt="망돌의 구원자가 되었다"
                title="망돌의 구원자가 되었다"
                href="/contents/2399789"
                coords="162,2584,2047,3232"
                shape="rect"
              />
              <area
                target="_self"
                alt="망한 가문의 마법사로 살아남기"
                title="망한 가문의 마법사로 살아남기"
                href="/contents/2400523"
                coords="160,3421,2041,4066"
                shape="rect"
              />
              <area
                target="_self"
                alt="신회귀자를 위한 지침"
                title="신회귀자를 위한 지침"
                href="/contents/2400097"
                coords="162,4261,2039,4905"
                shape="rect"
              />
              <area
                target="_self"
                alt="어느 날, 탑이 무너지기 시작했다"
                title="어느 날, 탑이 무너지기 시작했다"
                href="/contents/2400425"
                coords="162,5101,2047,5748"
                shape="rect"
              />
              <area
                target="_self"
                alt="온전한 하나가 될 수 있을까요"
                title="온전한 하나가 될 수 있을까요"
                href="/contents/2400515"
                coords="158,5940,2035,6592"
                shape="rect"
              />
              <area
                target="_self"
                alt="저승도 햇빛이 좋단다"
                title="저승도 햇빛이 좋단다"
                href="/contents/2400203"
                coords="164,6784,2045,7421"
                shape="rect"
              />
              <area
                target="_self"
                alt="플레이어가 접속했습니다"
                title="플레이어가 접속했습니다"
                href="/contents/2399826"
                coords="160,7623,2033,8262"
                shape="rect"
              />
              <area
                target="_self"
                alt="혈마는 정파가 되고 싶다!"
                title="혈마는 정파가 되고 싶다!"
                href="/contents/2400421"
                coords="162,8452,2039,9100"
                shape="rect"
              />
              <area
                target="_self"
                alt="작품 보러가기"
                title="작품 보러가기"
                href="/sections/pick-and-choo-list"
                coords="497,9570,1706,9997"
                shape="rect"
              />
            </map>
          </StyledScaleWrapper>
        </div>
        <div className="flex justify-center w-full bg-white">
          <img
            alt="event"
            id="image3"
            useMap="#image-map3"
            src={`${configure.staticPrefix}/images/contests/3/top10/3.png`}
            className="w-full h-auto"
          />
          <StyledScaleWrapper scale={scale} className="absolute left-0 w-full">
            <map name="image-map3">
              <area
                target="_self"
                alt="프로그램 안내 및 상세 FAQ"
                title="프로그램 안내 및 상세 FAQ"
                href={HELP_QNA_URL}
                coords="110,861,1003,1045"
                shape="rect"
              />
            </map>
          </StyledScaleWrapper>
        </div>
      </div>
    </MutableHeaderLayout>
  );
};

// 2400531	2317	2026353	쏠썬쑤뻠	괴이 때문에 집값이 떨어진다
// 2400377	2202	2003729	주인백	귀신을 본다고요? 당장 입사합시다
// 2399789	1947	2020246	달지	망돌의 구원자가 되었다
// 2400523	2311	2008406	선셰을	망한 가문의 마법사로 살아남기
// 2400097	2101	1972669	세모꿈	신회귀자를 위한 지침
// 2400425	2234	2021149	서이서	어느 날, 탑이 무너지기 시작했다
// 2400515	2303	2018572	달하	온전한 하나가 될 수 있을까요
// 2400203	2138	2025224	달고나팔자	저승도 햇빛이 좋단다
// 2399826	1977	2003291	2208	플레이어가 접속했습니다
// 2400421	2233	2004836	주5회연재	혈마는 정파가 되고 싶다!

export const StyledScaleWrapper = styled.div<{ scale: number }>`
  transform: scale(${({ scale = 0.3 }) => scale});
  transition: width 0.3s ease-in-out;

  @media (${isPC}) {
    transform: scale(1);
  }
`;
